import React from 'react';
import { Environments } from '../../../../types/global';
import { currentNetwork } from '../../../../utils/helpers';
const EXPLORER_BASE_URL = currentNetwork === Environments.Testnet
    ? 'https://testnet.ordinals.com'
    : 'https://ordinals.com';
export const RuneExplorerLink = ({ rune }) => (React.createElement("a", { href: `${EXPLORER_BASE_URL}/rune/${rune}`, target: "_blank", rel: "noopener noreferrer" }, rune));
